

export class ExpenseTypeStatusInput implements IExpenseTypeStatusInput {
    /** The auto-generated id of the expense type master */
    expenseTypeId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IExpenseTypeStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseTypeId = _data["expenseTypeId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ExpenseTypeStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseTypeId"] = this.expenseTypeId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IExpenseTypeStatusInput {
    /** The auto-generated id of the expense type master */
    expenseTypeId: number;
    /** The updated status */
    status: number;
}

